module.exports = __webpack_public_path__ + "static/media/Support.e99d852a.svg";